
<div class="d-flex justify-content-center">
    <h1 class="my-5">Coming soon!</h1>
</div>
<div class="d-flex justify-content-center">
<button (click)="back()" class="btn btn-primary">&lt; BACK</button>
</div>